<section id="app-reajuste-udemo" class="p-2">
  <div class="documento-aditivo-container">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
    <!-- <div *ngIf="ehCampanhaAniversarioFesp(dataCriacaoProposta)"> -->
    <div class="documento-aditivo-container">
      <h3 class="titulo text-center bold-preto-700 mb-1 p-1 mt-5" style="background: #ccc; border-radius: 10px">
        DECLARAÇÃO DE CIÊNCIA DE REAJUSTE
      </h3>
      <div class="col-md-12 col-sm-12 mt-1 espacamento-text-mobile">
        <p>
          Eu
          <span class="bold-preto-700" style="color: black">{{ nomeTitular }},</span>
          portador do CPF: {{ cpfTitular | cpf }}, declaro estar ciente que o valor expresso na proposta
          <b>PLANO UNIMED FESP/UDEMO nº.{{ codigoProposta }}, será reajustado</b>
          , a partir
          <b>01 de outubro de 2026</b>
          , em função da variação dos custos dos serviços médico-hospitalares. Declaro ainda, ter ciência que este e
          outros rajustes independem da data de adesão do meu contrato, os quais constram no verso da proposta de saúde
          coletivo por adesão.
        </p>
        <p class="mb-1">
          Nestas condições, concordo que o valor ora contratado terá reajuste a partir
          <b>01 de outubro de 2026</b>
          .
        </p>
      </div>
    </div>
  </div>
</section>
